import { useState } from "react";
//Material
import { Box, Grid } from "@mui/material";
//Components
import UserTextField from "./UserTextField";
//Icons
import WorkRoundedIcon from "@mui/icons-material/WorkRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
//Interfaces and Types
import { TCustomPhone, TUserPhonesProps } from "../../types/UserProfile";
import { ICommunication } from "@/Common/interfaces/user";
//Helpers
import { maskPhoneNumber } from "@/Common/helpers/functions";

const phoneHasExtension = (phone: string | undefined): boolean => {
	return phone?.includes("ext") ?? false;
};

const SPACE_FOUR_HALF = 4.4;
const SPACE_SIX = 6;

const getCommunicationValues = (communications: ICommunication[] = []): TCustomPhone[] => {
	const all: TCustomPhone[] = [];
	if (communications) {
		const businessList = communications.filter(
			(element: ICommunication) => element.communicationType === "PHONE" && element.usage === "BUSINESS"
		);
		const firstBusiness = businessList?.shift();
		const secondBusiness = businessList?.shift();

		const personal = communications
			.filter((element: ICommunication) => element.communicationType === "PHONE" && element.usage === "PERSONAL")
			.shift();

		all.push(
			firstBusiness
				? {
						...firstBusiness,
						space: phoneHasExtension(firstBusiness.value) ? SPACE_FOUR_HALF : true,
						id: `business-1-${firstBusiness.value}`,
				  }
				: { value: "Unknown", usage: "BUSINESS", space: true, id: "Unknown-1" }
		);

		if (secondBusiness) {
			all.push({
				...secondBusiness,
				space: phoneHasExtension(secondBusiness.value) ? SPACE_FOUR_HALF : true,
				id: `business-2-${secondBusiness.value}`,
			});
		}
		all.push(
			personal
				? { ...personal, space: true, id: `business-2-${personal.value}` }
				: { value: "Unknown", usage: "PERSONAL", space: true, id: "Unknown-2" }
		);
	}
	return all;
};

export default function UserProfilePhones(props: Readonly<TUserPhonesProps>) {
	const [allPhones] = useState<TCustomPhone[]>(getCommunicationValues(props.user?.communications));

	const defineXS = (phone: TCustomPhone): number | true => {
		if (allPhones.length === 2 || !phone?.space) {
			return SPACE_SIX;
		}
		return phone?.space;
	};

	return (
		<Grid container spacing={2} className="!w-[100%] !pl-[3px]">
			{allPhones?.map((phone: TCustomPhone) => {
				return (
					<Grid item container xs={defineXS(phone)} key={`phone-value-${phone?.id}`} className="!flex !w-[100%] relative">
						<Box className="absolute !left-[18px]">
							{phone?.usage?.includes("BUSINESS") ? (
								<WorkRoundedIcon className={"communication-icon-action"} />
							) : (
								<PersonRoundedIcon className={"communication-icon-action"} />
							)}
						</Box>
						<UserTextField value={maskPhoneNumber(phone?.value ?? null)} hasIcon={true} />
					</Grid>
				);
			})}
		</Grid>
	);
}
